import { get, post } from 'src/tools/server';

export const getPlanDetails = (storeUuid) => {
  return get<any>(`/config/store/plan/${storeUuid}`, {
    multipleRequests: true,
  });
};

export const getStoreRegion = (storeUuid) => {
  return get<any>(`/portal/store/region/${storeUuid}`, {
    multipleRequests: true,
  });
};

export const handleStripeSession = (storeUuid, stripePriceId?: string) => {
  const body = stripePriceId ? { stripePriceId } : {};
  return post<any>(`/config/store/billing/session/${storeUuid}`, body, {});
};

export const handleLicenceCode = (body) => {
  return post<any>(`/config/store/plan`, body, {});
};
export const cancelPlan = (storeUuid) => {
  return post<any>(`/config/store/plan/cancel/${storeUuid}`, {}, {});
};
